import _ from 'lodash'
import { Market } from 'src/interfaces/market'

export const filterChangedValues = <T extends Record<string, any>>(
  oldObject: Record<string, any>,
  newObject: T,
): Partial<T> => _.pickBy<T>(newObject, (value, key) => value !== oldObject[key])

export const addS = (count: number, text: string): string => {
  if (count === 1) {
    return text
  }

  return `${text}s`
}

export const addHaveHas = (count: number): string => {
  if (count === 1) {
    return 'has'
  }

  return 'have'
}

export const addIsAre = (count: number): string => {
  if (count === 1) {
    return 'is'
  }

  return 'are'
}

export const addSForString = (text: string): string => {
  if (text[text.length - 1] === 's') {
    return `${text}'`
  }

  return `${text}'s`
}

export const cutLongWord = (word: string, charsLimit = 20): string => {
  return word.length > charsLimit ? `${word.slice(0, charsLimit)}...` : word
}

export const promiseWithMinimalTime = <T = any>(promise: Promise<T>, executionTime = 3000) => {
  return Promise.all([
    promise,
    new Promise((res) => {
      setTimeout(() => {
        res(null)
      }, executionTime)
    }),
  ])
}

export const removeUnderscoresAndCapitalize = (str: string | null): string => {
  if (!str) {
    return '—'
  }

  const result = str.replace(/_/g, ' ')

  return result.charAt(0).toUpperCase() + result.slice(1)
}

export const isNonNullableArray = <T>(
  arr: (T | null | undefined)[] | undefined | null,
): arr is T[] => {
  return Array.isArray(arr) && arr.every((item): item is T => item !== null && item !== undefined)
}

export const capitalizeFirstLetter = (str: string): string => {
  if (!str) {
    return ''
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const delayMethod = (cb: () => void | Promise<void>, delay = 3000): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(async () => {
      await cb()

      resolve()
    }, delay)
  })
}

export const formatFullNameWithEmail = (
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string => {
  const first = firstName || ''
  const last = lastName || ''
  const name = `${first} ${last}`.trim()
  const safeEmail = email || ''

  if (name && safeEmail) {
    return `${name} (${safeEmail})`
  }

  return name || safeEmail || ''
}

export const formatMarketsData = (
  allMarkets?: boolean,
  markets?: Market[] | null,
  marketIds?: string[] | undefined,
): string => {
  if (allMarkets) {
    return 'All markets'
  }

  if (markets && markets.length > 0) {
    return markets.map((market) => market.title || market.id).join(', ')
  }

  if (marketIds && marketIds.length > 0) {
    return marketIds.join(', ')
  }

  return ''
}
